import React, {type FC} from 'react'
import {Select} from 'uikit'
import {LANGS} from 'src/lib/translates/consts'
import {type ValuesType} from 'src/providers/AdminProvider/AdminProvider'
import styles from './selectlang.scss'

type LanguagesType = Array<{
  name: string
  value: ValuesType
}>;

type Props = {
  onChange: (value: ValuesType) => void;
  value?: ValuesType;
}

const languages: LanguagesType = [
  {name: '------', value: null},
  {name: LANGS.RU, value: LANGS.RU},
  {name: LANGS.UK, value: LANGS.UK},
  {name: LANGS.EN, value: LANGS.EN},
  {name: LANGS.TR, value: LANGS.TR},
];

export const SelectLang: FC<Props> = ({onChange, value}) => (
  <Select<ValuesType >
    onChange={onChange}
    options={languages}
    value={value}
    classNameSelected={styles.selected}
    className={styles.wrapper}
  />
)
